import React, { useEffect, useState } from 'react';
import { Button, Spin } from 'antd';
import { useCustomer } from '../../../../../core-module/hooks';
import { CustomerInformationForBezorgmomentenResponse } from '../../../../../core-module/services/deliverer/types';
import { OrderHistoryContainer } from './OrderHistoryContainer';
import { Delivery } from '../../../../../core-module/models/OrderHistory/OrderHistory';
import { OrderEditFormComponent } from './OrderEditFormComponent';
import OrderFormContainer from './OrderFormContainer';

interface Props {
  customerId: number;
}

const OrderTab: React.FC<Props> = ({ customerId }) => {
  const [showOrderHistory, setshowOrderHistory] = useState(true);
  const [showCreateOrderForm, setShowCreateOrderForm] = useState(false);
  const [editDelivery, setEditDelivery] = useState<Delivery | undefined>();
  const [hasValidPaymentMethod, setHasValidPaymentMethod] = useState(false);

  const { customer, error, loading } = useCustomer(customerId, true);

  useEffect(() => {
    if (customer && customer.payment_method) {
      const isValid =
        customer.payment_method === 'DirectDebit' || customer.payment_method === 'Invoice';
      setHasValidPaymentMethod(isValid);
    }
  }, [customer]);

  const handleOpenCreateForm = () => {
    setshowOrderHistory(false);
    setShowCreateOrderForm(true);
    setEditDelivery(undefined);
  };

  const handleCloseCreateForm = () => {
    setshowOrderHistory(true);
    setShowCreateOrderForm(false);
    setEditDelivery(undefined);
  };

  const handleOpenEditForm = (delivery: Delivery) => {
    setshowOrderHistory(false);
    setShowCreateOrderForm(false);
    setEditDelivery(delivery);
  };

  const handleCloseEditForm = () => {
    setshowOrderHistory(true);
    setShowCreateOrderForm(false);
    setEditDelivery(undefined);
  };

  if (loading) {
    return <Spin spinning={true}>Klant uit camasys aan het ophalen...</Spin>;
  }

  if (error || !customer) {
    return <p>Er is een fout opgetreden bij het ophalen van het profiel.</p>;
  }

  const customerInformation: CustomerInformationForBezorgmomentenResponse = {
    customerNumber: customer?.customer_id,
    postalCode: customer?.postal_code ?? '',
    paymentMethod: customer?.payment_method ?? ''
  };

  if (showOrderHistory) {
    return (
      <>
        <Button
          type='primary'
          icon='plus'
          style={{ marginBottom: 15 }}
          onClick={() => handleOpenCreateForm()}
        >
          Bestelling invoeren
        </Button>

        <OrderHistoryContainer customer={customer} onEditClick={handleOpenEditForm} />
      </>
    );
  }

  if (showCreateOrderForm) {
    return (
      <OrderFormContainer
        customerInformation={customerInformation}
        onHideClick={handleCloseCreateForm}
        customerDefaultPortionSize={customer.default_portie}
        hasValidPaymentMethod={hasValidPaymentMethod}
      />
    );
  }

  if (editDelivery) {
    return (
      <OrderEditFormComponent
        salesOrderId={editDelivery.salesOrderId}
        deliveryId={editDelivery.deliveryId}
        onHideClick={handleCloseEditForm}
      />
    );
  }

  return <p>Something went wrong</p>;
};

export { OrderTab };
